import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {StockService} from "../../../services/api/stocks/stock.service";
import {StockByProductResponse, StockResponse} from "../../../services/api/stocks/model";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable
} from "@angular/material/table";
import {MatIcon} from "@angular/material/icon";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {format_price} from "../../../utils/helper";

@Component({
  selector: 'app-stocks-general-page',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatRow,
    MatRowDef,
    MatTable,
    NgForOf,
    ReactiveFormsModule,
    MatHeaderCellDef,
    NgIf,
    NgClass
  ],
  templateUrl: './stocks-general-page.component.html',
  styleUrl: './stocks-general-page.component.css'
})

export class StocksGeneralPageComponent implements OnInit, OnChanges {

  stocksData: StockByProductResponse[] = [];
  selectedRow: StockByProductResponse | undefined;
  selectedStockData: StockResponse[] = [];
  filterData: StockByProductResponse[] = [];
  isProductDetailOpen = false;
  aggregatedColumns: string[] = ['item_name', 'total_quantity', 'minimum_quantity'];
  detailsColumns: string[] = ['item_name', 'location_id', 'production_date', 'expiration_date', 'actual_quantity', 'item_id'];

  @Input() refreshTable: boolean = false;
  @Output() sendItemToAdd: EventEmitter<StockResponse> = new EventEmitter<StockResponse>();
  @Output() sendItemRetire: EventEmitter<StockResponse> = new EventEmitter<StockResponse>();

  constructor(
    private stockService: StockService,
    public route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.getStock();
  }

  ngOnChanges() {
    this.getStock();
    this.updateDetailedStock();
  }

  getStock() {
    const stockLevel = this.route.snapshot.paramMap.get('stock-level');
    this.stockService.getStocksByProduct().subscribe(res => {
        this.stocksData = res;
        this.filterData = res;
        if (stockLevel && stockLevel === "low-stock") {
          this.filterLowStockData();
        } else if (stockLevel && stockLevel === "out-stock") {
          this.filterOutOfStockData();
        } else if (stockLevel && stockLevel === "in-stock") {
          this.filterInStockData();
        }
      }
    )
  }

  searchResults(text: string) {
    this.filterData = text.trim() === ""
      ? this.stocksData
      : this.stocksData.filter(item => item?.item_name.toLowerCase().includes(text.toLowerCase()));
  }


  select(row: StockByProductResponse) {
    this.selectedRow = row;
    this.updateDetailedStock();
  };

  updateDetailedStock() {
    if (this.selectedRow) {
      this.stockService.getStocksByItemID(this.selectedRow.item_id).subscribe(res => {
        this.selectedStockData = res.sort((a, b) => a.expiration_date.localeCompare(b.expiration_date) || a.location_id - b.location_id);
        this.isProductDetailOpen = true;
      })
    }
  }

  formatDateToMMDDYYYY(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  closeTable() {
    this.isProductDetailOpen = false;
  }

  isStockLow(actual_quantity: number, minimum_quantity: number): boolean {
    return actual_quantity <= minimum_quantity;
  }

  isExpirationAlerted(expirationDate: string | Date, threshold: number): boolean {
    const today = new Date();
    const expDate = new Date(expirationDate);

    // Calculate the difference in milliseconds
    const timeDifference = expDate.getTime() - today.getTime();

    // Calculate the difference in days
    const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    // Return true if the number of days is less than the threshold
    return dayDifference <= threshold;
  }

  filterLowStockData() {
    this.filterData = this.filterData.filter(
      stock => stock.total_quantity <= stock.minimum_quantity && stock.total_quantity > 0
    )
  }

  filterOutOfStockData() {
    this.filterData = this.filterData.filter(stock => stock.total_quantity === 0)
  }

  filterInStockData() {
    this.filterData = this.filterData.filter(stock => stock.total_quantity > 0)
  }

  protected readonly format_price = format_price;
}
